import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
  Avatar,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

interface Props {
  title: string;
  onMenuClick?: () => void;
}

// Simula datos del usuario
const user = {
  nombre: localStorage.getItem('fullname'),
};

export default function DashboardHeader({ title, onMenuClick }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getInitials = (name: string) => {
    const names = name.trim().split(' ');
    if (names.length === 1) return names[0][0];
    return names[0][0] + names[names.length - 1][0];
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/ingreso';
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{ backgroundColor: '#f3f3f3', color: '#000' }}
    >
      <Toolbar>
        {isMobile && (
          <IconButton edge="start" onClick={onMenuClick}>
            <MenuIcon />
          </IconButton>
        )}

        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            component="img"
            src="/logo.png"
            alt="Rodaris"
            sx={{
              height: 30,
              width: 'auto',
            }}
          />
        </Box>

        {/* ==============================
              Perfil del usuario
          ============================== */}
          <Box display="flex" alignItems="center" gap={1} px={5}>
            <Avatar sx={{ bgcolor: '#000', width: 32, height: 32, fontSize: 14 }}>
              {getInitials(user.nombre!).toUpperCase()}
            </Avatar>

            <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column' }}>
              <Typography variant="body2" fontWeight="medium">
                {user.nombre}
              </Typography>
              <Typography sx={{ fontSize: '11px' }} fontWeight="normal">
                Super Administrador
              </Typography>
            </Box>

            <IconButton onClick={handleLogout} sx={{ ml: 1, p: 0 }}>
              <img
                src="/assets/icons/log-out.png"
                alt="Logout"
                style={{ width: 24, height: 24, cursor: 'pointer' }}
              />
            </IconButton>
          </Box>

      </Toolbar>
    </AppBar>
  );
}
